import { createMuiTheme } from "material-ui/styles"
import {
  blue,
  green,
  teal,
  grey,
  pink,
  white,
  blueGrey
} from "material-ui/colors"

export const styles = {
  fontFamily: "Roboto, Lato, Arial, sans-serif",
  palette: {
    primary: {
      50: blue[500],
      100: blue[100],
      200: blue[500],
      300: blue[500],
      400: blue[500],
      500: blue[500],
      600: blue[500],
      700: blue[500],
      800: blue[500],
      900: blue[500],
      A100: blue[500],
      A200: blue[500],
      A400: blue[500],
      A700: blue[500],
      contrastDefaultColor: "light"
    },
    secondary: {
      50: "#00e676",
      100: "#00e676",
      200: "#00e676",
      300: "#00e676",
      400: "#00e676",
      500: "#00e676",
      600: "#00e676",
      700: "#00e676",
      800: "#00e676",
      900: "#00e676",
      A100: "#B9F6CA",
      A200: "#00e676",
      A400: "#00C853",
      A700: "#00e676",
      contrastDefaultColor: "dark"
    },

    // Below are default Material-UI colors and DO NOT require a color #
    consumer: green,
    pro: blue,
    error: pink,

    // Below are custom colors that we defined and DO require a color #
    white: grey[50],

    textColor: grey[900],
    secondaryTextColor: grey[700],
    backgroundColor: grey[100],
    nullStateIconColor: grey[300],
    iconColor: grey[500],
    deleteRowIcon: grey[300],
    buttonBackgroundColor: grey[300],
    borderColor: grey[300],
    toolbarBackground: grey[100],
    toolbarIconColor: grey[600],
    selectedToolbarBackground: blue[50],
    selectedToolbarTitleColor: blue[700],
    selectedToolbarIconColor: blue[700],
    selectedToolbarDisabledIconColor: blue[200],
    deletedItemsToolbarBackground: pink[300],
    adminToolbar: teal[600],
    adminToolbarDarkFontColor: teal["A100"],
    onboardingToolbar: "#00314a",
    onboardingToolbarIcon: "#FFFFFF",
    onboardingIndustryCard: blue[500],
    onboardingIndustryCardActive: "#D8D8D8",
    newAction: blue[500],
    newActionHover: "#1A76D2",
    starColor: "#ffd54f"
  },
  typography: {
    useNextVariants: true,
    button: {
      fontSize: 14
    },
    caption: {
      fontSize: 12,
      color: grey[700]
    },
    body1: {
      fontSize: 16,
      fontWeight: 400
    },
    body1Subdued: {
      fontSize: 16,
      fontWeight: 400,
      fontColor: grey[700]
    },
    body2: {
      fontSize: 14,
      fontWeight: 400
    },
    body2Subdued: {
      fontSize: 14,
      fontWeight: 400,
      fontColor: grey[700]
    },
    subheading: {
      fontSize: 16,
      fontWeight: 500
    },
    title: {
      fontSize: 20,
      fontWeight: 500
    },
    headline: {
      fontSize: 24,
      fontWeight: 400
    },
    display1: {
      fontSize: 34,
      color: grey[900]
    },
    display2: {
      fontSize: 48,
      fontWeight: 500,
      color: grey[900]
    }
  },
  dialogSpinner: {
    backgroundColor: "#f7f7f7",
    position: "absolute",
    zIndex: 20,
    top: 0,
    left: 0,
    opacity: 0.9,
    height: "100%",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },

  overrides: {
    MuiCardHeader: {
      title: {
        fontSize: 16,
        fontWeight: 500
      }
    }
  }
}

export const latestMuiTheme = createMuiTheme(styles)

export default latestMuiTheme
